import { render, staticRenderFns } from "./TemplateBackground.vue?vue&type=template&id=2c5386a8&"
import script from "./TemplateBackground.vue?vue&type=script&lang=ts&"
export * from "./TemplateBackground.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports